import React, { useEffect, useRef, useState } from "react";
import { ChevronDown, ChevronLeft, ChevronRight, ChevronUp } from "lucide-react";
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from "@/components/ui/resizable";
import { MOSAIC_MAP_PCT } from "@/lib/geo";
import { useLang } from "@/lib/i18n";

export const MapResultsLayout = ({ mosaic, onMosaicChange, list, map }) => {
  const { t } = useLang();
  const mapPanelRef = useRef(null);
  const [vertical, setVertical] = useState(false);
  const [mapPct, setMapPct] = useState(55);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 639px)");
    const apply = () => setVertical(mq.matches);
    apply();
    mq.addEventListener("change", apply);
    return () => mq.removeEventListener("change", apply);
  }, []);

  useEffect(() => {
    onMosaicChange?.(mapPct < MOSAIC_MAP_PCT);
  }, [mapPct, onMosaicChange]);

  const toggleCollapse = () => {
    const panel = mapPanelRef.current;
    if (!panel) return;
    if (mosaic || mapPct < MOSAIC_MAP_PCT) panel.resize(55);
    else panel.resize(12);
  };

  const CollapseIcon = vertical
    ? (mosaic ? ChevronUp : ChevronDown)
    : (mosaic ? ChevronLeft : ChevronRight);

  return (
    <ResizablePanelGroup
      data-testid="map-results-layout"
      direction={vertical ? "vertical" : "horizontal"}
      className="h-full"
    >
      <ResizablePanel defaultSize={45} minSize={22} className="min-h-0 min-w-0">
        {list}
      </ResizablePanel>
      <ResizableHandle withHandle />
      <ResizablePanel
        ref={mapPanelRef}
        defaultSize={55}
        minSize={0}
        collapsible
        collapsedSize={0}
        onResize={setMapPct}
        className="relative min-h-0 min-w-0"
      >
        {map}
        <button
          type="button"
          data-testid="collapse-map-button"
          aria-label={mosaic ? t("expand_map") : t("collapse_map")}
          onClick={toggleCollapse}
          className={`absolute z-[500] flex h-8 w-8 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-sm hover:bg-slate-50 ${
            vertical ? "bottom-2 left-1/2 -translate-x-1/2" : "left-2 top-1/2 -translate-y-1/2"
          }`}
        >
          <CollapseIcon className="h-4 w-4" />
        </button>
      </ResizablePanel>
    </ResizablePanelGroup>
  );
};
